const moment = require('moment-timezone');
const { get, isNil } = require('lodash');

module.exports = function (value, eventDetails = {}, meta = {}) {
  const DISPLAY_FORMAT = get(meta, 'settings.format', 'LL LT');
  if (value && moment(value).isValid()) {
    return eventDetails && eventDetails.timezone
      ? moment(value).tz(eventDetails.timezone).format(DISPLAY_FORMAT)
      : moment(value).format(DISPLAY_FORMAT);
  }
  return value;
};
